import React from 'react';
export function AgitationSection() {
  return <section className="bg-forest-900 py-20 px-4" data-id="element-1">
      <div className="max-w-3xl mx-auto space-y-12 text-lg md:text-xl text-forest-50 leading-relaxed" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center" data-id="element-3">
          ¿Te suena familiar?
        </h2>

        <div className="space-y-6" data-id="element-4">
          <p data-id="element-5">Son las 7 de la tarde.</p>
          <p data-id="element-6">Comiste bien todo el día. Ensalada, fruta, legumbres.</p>
          <p data-id="element-7">Pero tu panza parece la de alguien de 6 meses de embarazo.</p>
          <p data-id="element-8">Te desabrochás el botón del pantalón y pensás:</p>

          <div className="pl-6 border-l-4 border-gold-400 italic space-y-2 py-2 text-gold-400 font-medium" data-id="element-9">
            <p data-id="element-10">"¿Por qué me pasa esto si estoy comiendo sano?"</p>
          </div>

          <p data-id="element-11">
            Vas al médico. Te dicen:{' '}
            <span className="font-bold" data-id="element-12">
              "Es colon irritable. Tomá este antiespasmódico."
            </span>
          </p>
          <p data-id="element-13">Lo tomás. Mejora dos semanas. Vuelve todo.</p>
          <p className="font-bold text-white text-xl md:text-2xl pt-4" data-id="element-14">
            Eso no es una falla tuya. Es tu biología sin el mapa correcto.
          </p>
        </div>
      </div>
    </section>;
}